module.exports = __webpack_public_path__ + "static/media/400417_02.31bdd644.png";